import { CruiseExpiration, isCourtesyHoldExpired } from "@ssc-booking/api-contracts"
import { useECommerceMachine } from "../../_common/machines/machines-context"
import { isNullOrUndefined } from "../../_common/checks"

type UseCourtesyHold =
    | ({
          type: "available"
      } & CruiseExpiration)
    | { type: "expired" }

export const useCourtesyHold = (): UseCourtesyHold => {
    const [state] = useECommerceMachine()

    const cruiseExpiration = state.context.cruiseInfo?.expiration

    if (isNullOrUndefined(cruiseExpiration) || isCourtesyHoldExpired(cruiseExpiration)) return { type: "expired" }
    return { type: "available", ...cruiseExpiration }
}
